import React from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import 'antd/dist/antd.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
// import Footer from "./Components/Footer/Footer"
import UserHome from './Pages/UserHome/UserHome.js'
import { ProtectedRoute } from './Components/ProtectedRoute/ProtectedRoute.js';
import { RequireAuth } from './Components/RequireAuth/RequireAuth'

import WithoutNav from './Components/WithoutNav/WithoutNav';
import LoginIn from './Pages/Login/Login.js'
import VehicleForm from './Pages/Form/VehicleForm/VehicleForm.js';
import Example from './Pages/Example/Example'
import ErrorPage from './Pages/404.js';
import WithNav from './Components/WithNav/WithNav';
import VehicleCatalog from './Pages/VehicleCatalog/VehicleCatalog'
import SingleVehicle from './Pages/SingleVehicle/SingleVehicle';

import WithSideNav from './Components/WithSideNav/WithSIdeNav.js';
import DashBoard from './Pages/AdminHome/DashBoard/DashBoard'
import Auction from './Pages/AdminHome/Auction/Auction.js';
// import FlowChart from './Pages/AdminHome/FlowChart/FlowChart';
import Vehicle from './Pages/AdminHome/Vehicle/Vehicle.js';
import Customer from './Pages/AdminHome/Customer/Customer.js';
import AuctionRep from './Pages/AdminHome/Auction/AuctionReport.js';
import MakeComponent from './Pages/AdminHome/Make/Make.js';
import EmployeeComponent from './Pages/AdminHome/Employee/Employee.js'
import LaborComponent from './Pages/AdminHome/Labor/Labor.js'
import ModelComponent from './Pages/AdminHome/Model/Model.js';
import TaskComponent from './Pages/AdminHome/Task/Task.js';
import SalesModel from './Pages/AdminHome/Sales/SalesModel'
import SalesByDate from './Pages/AdminHome/Sales/SalesByDate.js';
import Sales from './Pages/AdminHome/Sales/Sales'
import FAQ from './Pages/FAQ/FAQ'

function App() {

  return (
    <div className="App">
      <ProtectedRoute>
        <Router>
          <Routes>
            <Route element={<WithNav />}>
              <Route exact path="/" element={<UserHome />} />
              <Route exact path="/vehicle-catalog" element={<VehicleCatalog />} />
              <Route exact path="/vehicle-catalog/:vehicleid/" element={<SingleVehicle />} />
              <Route exact path="/FAQ" element={<FAQ />} />

            </Route>
            <Route element={<WithoutNav />}>
              <Route path="/LogIn" element={<LoginIn />} />
              <Route path="/VehicleForm" element={<VehicleForm />} />
              <Route path="*" element={ <ErrorPage/>}/>
            </Route>
            { /* Routes we want to protect */ }
            <Route element={<WithSideNav/>}>
              {/* <Route exact path="/DashBoard" element={<RequireAuth><DashBoard /></RequireAuth>} /> */}
              <Route exact path="/DashBoard" element={<RequireAuth><DashBoard /></RequireAuth>} />

              <Route exact path="/Vehicle" element={<RequireAuth><Vehicle /></RequireAuth>} />
              {/* <Route exact path="/Vehicle" element={<Vehicle />} /> */}
              <Route exact path="/Auction" element={<RequireAuth><Auction /></RequireAuth>} />
              <Route exact path="/Example" element={<Example /> } />
              {/* <Route exact path="/FlowChart" element={<FlowChart />} /> */}
              <Route exact path="/Sales" element={<RequireAuth><Sales /></RequireAuth>} />
              <Route exact path="/SalesModel" element={<RequireAuth><SalesModel /></RequireAuth> } />
              <Route exact path="/SalesByDate" element={<RequireAuth><SalesByDate /> </RequireAuth>} />
              <Route exact path="/Task" element={<RequireAuth><TaskComponent /></RequireAuth>} />
              <Route exact path="/Customer" element={<RequireAuth><Customer /></RequireAuth>} />
              <Route exact path="/AuctionRep" element={<RequireAuth><AuctionRep /></RequireAuth>} />
              <Route exact path="/Makes" element={<RequireAuth><MakeComponent /></RequireAuth>} />
              <Route exact path="/Employee" element={<RequireAuth><EmployeeComponent /></RequireAuth>} />
              {/* <Route exact path="/Employee" element={<EmployeeComponent />} /> */}
              <Route exact path="/Labor" element={<RequireAuth><LaborComponent /></RequireAuth>} />
              <Route exact path="/Model" element={<RequireAuth><ModelComponent /></RequireAuth>} />
              { /* Routes we want to protect */ }

            </Route>
          </Routes>
        </Router>
        </ProtectedRoute>
      {/* {Location.pathname !== "/" && <Footer/>} */}
    </div>
  );
}

export default App;
